import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { StyledComprobante } from "../../styled/Reintegros";

const ComprobanteDetail = ({ open, handleCloseDetail }) => {

  const postReintegro = useSelector(
    (state) => state.reintegros.postReintegro.comprobantes
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const columns = [
    { id: "rubro", label: "Rubro" },
    { id: "importe", label: "Importe" },
  ];

  return (
    <Dialog open={open}>
      <StyledComprobante.DialogTitle>
        Detalle del Comprobante{" "}
        {<StyledComprobante.Icon component={Close} onClick={handleCloseDetail} />}
      </StyledComprobante.DialogTitle>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? postReintegro.data.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : postReintegro.data
            ).map((row, index) => {
              return (
                <TableRow key={index + 1}>
                  <TableCell>{row.nombre}</TableCell>
                  <TableCell>
                    ${" "}
                    {parseFloat(row.importe).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default ComprobanteDetail;
